<template>
  <div class="ai-chat-container">
    <div class="chat-card-list">
      <Card class="chat-card">
        <div class="card-content"  @click="openChat('https://d.inbgz.com/chat/AILJK5rybDKgV3QE')">
          <div class="xcard-icon">
            <Icon type="ios-chatbubbles" size="48" color="#2d8cf0" />
          </div>
          <div class="card-title">监理知识库专家问答</div>
          <div class="card-description">智能问答系统，解答监理相关专业问题</div>
        </div>
      </Card>

      <!-- 可以在此处添加更多卡片 -->

    </div>
  </div>
</template>

<script>
export default {
  methods: {
    openChat(url) {
      window.open(url, '_blank');
    },
  },
};
</script>

<style scoped>
.ai-chat-container {
  padding: 24px;
  background-color: #f8f8f9;
  min-height: 100%;
}

.chat-card-list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.chat-card {
  width: 280px;
  height: 200px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.chat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.card-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
}

.card-icon {
  margin-bottom: 16px;
}

.xcard-title {
  font-size: 18px;
  font-weight: 500;
  color: #17233d;
  margin-bottom: 10px;
}

.card-description {
  font-size: 14px;
  color: #808695;
}
</style>
